/**
 * @description: 公共的常量
 */

// storage 名称
const STORAGE_NAME = {
  token: 'Authorization', // token
  userInfo: 'qzjUserInfo' // 用户信息
};

// User-Source
const USER_SOURCE = '5001';

// X-Time-Version
const X_TIME_VERSION = '2.0';

// 商户code
const MERCHANT_CODE = {
  zxkj: '3001', // 掌薪科技
  jrrl: '3002',  // 君润人力
  yr: '3003', // 亿融
  xr: '3004', // 鑫融
  yr2: '3005'  // 亿融2
};

// Source-Type
const SOURCE_TYPE = {
  jd: 'JD_MP'
};

// H5活动点击后跳转类型
const ACTIVITY_SKIP_TYPE = {
  empty: 'NO', // 不跳转
  register: 'REGISTER', // 弹注册窗
  link: 'LINK_TO' // 跳转链接
};

// H5注册弹窗样式类型
const REGISTER_POPUP_TYPE = {
  blue: 'BLUE', // 蓝色
  orange: 'ORANGE', // 橙色
  yellow: 'YELLOW' //黄色
};

// H5活动注册成功页面跳转类型
const ACTIVITY_LINK_TYPE = {
  in: 'IN', // 内部链接(内部配置的活动)
  out: 'OUT', // 外部链接
  outMp: 'OUT_MP' // 跳转小程序
};

// 活动状态
const ACTIVITY_STATUS = {
  effective: 'EFFECTIVE', //有效
  ineffective: 'INEFFECTIVE' //失效
};

export {
  STORAGE_NAME,
  USER_SOURCE,
  X_TIME_VERSION,
  MERCHANT_CODE,
  SOURCE_TYPE,
  ACTIVITY_SKIP_TYPE,
  REGISTER_POPUP_TYPE,
  ACTIVITY_LINK_TYPE,
  ACTIVITY_STATUS
};
